import { useRouteError } from "react-router";

export function RootErrorBoundary() {
  const error = useRouteError();
  console.error("Unhandled error:", error);
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Something went wrong</h1>
        <p className="text-muted-foreground mt-2">Please refresh the page and try again.</p>
        <button
          className="mt-4 rounded bg-neutral-900 px-4 py-2 text-white"
          type="button"
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
